import { PropType, computed, defineComponent } from 'vue'
import { Store } from 'pinia'
import { MapViewMode } from '../../contract/map'
import { ChargeMapContext } from '../chargerMap/index.model'
import { ComponentActions, ComponentState } from '../../nsh5/localStores/component'
import IconRender from './iconRender'

export default defineComponent({
  name: 'icon-render-view',
  props: {
    mapContextRef: {
      type: Object as PropType<ChargeMapContext>,
    },
    mapInstance: {
      type: Object,
    },
    componentStore: {
      // 用于同一项目功能模块间的通信
      type: Object as PropType<Store<string, ComponentState, {}, ComponentActions>>,
      default: null,
    },
  },

  setup: (props) => {
    const componentStore = computed(() => props.componentStore)
    const mapContextRef = computed(() => props.mapContextRef)
    const mapInstance = computed(() => props.mapInstance)
    return () => (
      <>
        {/* 新站上新和县县通模式不需要使用iconRender组件,不然route变化会走到组件里 */}
        {componentStore.value.viewMode !== MapViewMode.NewStation &&
        componentStore.value.viewMode !== MapViewMode.CountyLayout ? (
          <IconRender
            mapContextRef={mapContextRef.value}
            mapInstance={mapInstance.value}
            componentStore={componentStore.value}
          ></IconRender>
        ) : null}
      </>
    )
  },
})
